import { IconCircleFilled, IconCircleCheckFilled, IconCircleXFilled } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import { specialCharacters } from "./helper";

const passwordValidations = [
  "Be at least 12 characters long",
  "Contain at least one uppercase letter",
  "Contain at least one lowercase letter",
  "Contain at least one number",
  `Contain at least one special character (${specialCharacters.toString().slice(2, -2)})`,
];

interface PasswordValidationProps {
  validatePassword: number[];
}

export const PasswordValidation = ({ validatePassword }: PasswordValidationProps) => {
  const hasError = validatePassword.includes(-1);
  const isSuccess = !hasError && !validatePassword.includes(0);

  return (
    <div
      className={cn(
        "al-rounded-b-xl al-p-2 al-text-sm",
        hasError && "al-bg-red-50 al-text-red-500",
        isSuccess && "al-bg-green-50",
        !hasError && !isSuccess && "al-bg-gray-100 al-text-gray-500"
      )}
    >
      <span className="al-text-black">Password Should:</span>
      {validatePassword.map((val, idx) => (
        <div
          key={idx}
          className={cn(
            "al-flex al-items-center al-gap-1",
            val === 0 && "al-text-gray-400",
            val === 1 && "al-text-green-600",
            val === -1 && "al-text-red-500"
          )}
          data-validation-state={val === 0 ? "pending" : val === 1 ? "valid" : "invalid"}
          aria-label={`${passwordValidations[idx]} - ${val === 0 ? "pending" : val === 1 ? "valid" : "invalid"}`}
        >
          {val === 0 ? (
            <IconCircleFilled size={14} />
          ) : val === 1 ? (
            <IconCircleCheckFilled size={14} />
          ) : (
            <IconCircleXFilled size={14} />
          )}
          <span>{passwordValidations[idx]}</span>
        </div>
      ))}
    </div>
  );
};
